import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchSinglePatient = async (patientId, trialId) => {
  const token = localStorage.getItem("token");

  const params = { patientId };
  if (trialId) {
    params.trial_id = trialId;
  }

  const response = await axios.get(`${__API_URL__}/api/patient/patient/singlepatient/`, {
    params,
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data;
};

const useGetSinglePatient = ({ patientId, trialId, enabled = true }) => {
  return useQuery({
    queryKey: ["single_patient", patientId, trialId],
    queryFn: () => fetchSinglePatient(patientId, trialId),
    enabled: enabled && !!patientId,
  });
};

export default useGetSinglePatient;
